import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { VanCard } from "../../components/Cards/VanCard";
import axios from "axios";
import { VEHICLES_LIST } from "../../URLs/Apis";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import "./Vehicles.css";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Autocomplete, Pagination, Stack, TextField } from "@mui/material";
import { newHost } from "../Categories/CategoryProfile";
import { toast } from "react-toastify";
import defaultImage from "../../assets/svg/defultImage.svg"



const Vehicles = () => {

  const { user } = useSelector((state) => state.auth);
  const token = user?.token
  const [vanList, setVanList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [show, setShow] = useState(false);
  const [vehicleBrands, setVehicleBrands] = useState([])
  const [properties, setProperties] = useState([])
  const [imagePreview, setImagePreview] = useState(null)
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);

  const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setValue("profile_photo", file);
    };
    reader.readAsDataURL(file);
  };

  const handleClose = () => {
    setShow(false)
    reset({
      model_id: "",
      brand_id: null,
      year: "",
      odometer_reading: "",
      chassis_number: "",
      plate_number: "",
      properties: [
        {
          property_id: "",
          value_id: ""
        }


      ]
    })
    
    setImagePreview(null)
  }

  const handleShow = () => {
    setShow(true)
  };

  const getVanList = async () => {
    const formattedDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : "";
    try {
      const response = await axios.get(
        `${VEHICLES_LIST}?execution_date=${formattedDate}&page=${page}&per_page=16
        `,
        {
          headers: {
            Authorization: "Bearer " + user?.token,
          },
        }
      );
      setVanList(response.data.data.door_step_vehicles);
      setPagination(response.data.data.pagination);
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false)
    }
  };

  const getAllVehiclesSpecifications = async () => {
    try {
      const response = await axios.get(`${newHost}cars/specifications`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setVehicleBrands(response.data.data.brands || null)
      setProperties(response.data.data.properties)
      
    } catch (error) {

    }
  }
 

  const submitVehicles = async (data) => {
    const formData = new FormData();


    if (data.profile_photo && data.profile_photo !== null) {
      formData.append("profile_photo", data.profile_photo);
    }

    formData.append("brand_id", data.brand_id);
    formData.append("model_id", data.model_id);
    formData.append("year", data.year);
    formData.append("odometer_reading", data.odometer_reading);
    formData.append("chassis_number", data.chassis_number);
    formData.append("plate_number", data.plate_number);
    data.properties.forEach((property, index) => {


      formData.append(`properties[${index}][property_id]`, property.property_id)
      formData.append(`properties[${index}][value_id]`, property.value_id)

    })
    try {
      const response = await axios.post(`${newHost}portal/door_step_vehicles`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      getVanList()
      handleClose()
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message)
    }
  }
  useEffect(() => {
    if (properties.length) {
      reset({
        ...watch(),
        properties: properties.map((prop) => ({
          property_id: prop.id,
          value_id: ""
        }))
      })
    }
  }, [properties])

  useEffect(() => {
    getVanList();
  }, [selectedDate,page]);
  useEffect(() => {
  setPage(1);
}, [selectedDate]);

  useEffect(() => {
    getAllVehiclesSpecifications();
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
    watch
  } = useForm({
    defaultValues: {
      model_id: "",
      brand_id: null,
      year: "",
      odometer_reading: "",
      chassis_number: "",
      plate_number: "",
      properties: [
        {
          property_id: "",
          value_id: ""
        }

      ]
    },
  })

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-size">
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black">Add Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{}}>
          <form action="" onSubmit={handleSubmit(submitVehicles)}>
            <div className="d-flex justify-content-between align-items-center p-4 company-logo-upload input-group-responsive">
              <div className="d-flex align-items-center upload-file-responsive">
                <div style={{ width: "50px", height: "50px" }} className="">
                  <img
                    className="w-100"

                    src={
                      imagePreview
                        ? imagePreview
                        :
                        defaultImage
                    }
                    alt="profile_photo"
                  />
                </div>



                {imagePreview ? null : <p className="fw-bold my-0 mx-2 supplier-label-size">Upload an image. Max size 2MB</p>
                }

              </div>
              <label htmlFor="profile_photo" className="btn btn-light">

                Browser
                <input onChange={FileChange} type="file" id="profile_photo" className="d-none " />


              </label>

            </div>
            <div className="row mt-3">

              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Brands</label>

                  <Controller
                    name="brand_id"
                    control={control}
                    rules={{
                      required: `The Brand is required`
                    }}
                    render={({ field }) => (

                      <Autocomplete
                        size="small"
                        options={vehicleBrands.map((option) => {
                          return {
                            label: option.name,
                            id: option.id,
                          }


                        })}

                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}

                        renderOption={(props, option) => (
                          <li
                            {...props}
                            className="p-2"
                          >
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => <TextField {...params} placeholder="Select Brand"

                          error={!!errors?.brand_id}
                        />}
                      />

                    )}
                  />
                  {errors?.brand_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.brand_id?.message}
                    </p>
                  )}

                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Model</label>
                  <Controller
                    name={`model_id`}
                    control={control}
                    rules={{
                      required: `The Model is required`
                    }}
                    render={({ field }) => {
                      const selectedBrandId = watch(`brand_id`);
                      const selectedBrand = vehicleBrands.find(
                        (brand) => brand.id == selectedBrandId
                      );
                      const availableModels = selectedBrand?.models || [];
                      console.log(selectedBrandId);
                      return (
                        (
                          <Autocomplete
                            size="small"
                            options={availableModels.map((option) => {
                              return {
                                label: option.name,
                                id: option.id
                              }
                            })}
                            onChange={(e, item) => {
                              field.onChange(item ? item.id : null);
                            }}

                            renderOption={(props, option) => (
                              <li {...props} className="p-2">
                                <div className="label-size m-0">{option.label}</div>
                              </li>
                            )}


                            renderInput={(params) => (
                              <TextField {...params} placeholder="Select Model"
                                error={!!errors?.model_id}
                              />
                            )}
                          />

                        )
                      )
                    }
                    }
                  />
                  {errors?.model_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.model_id?.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Year</label>
                  <Controller
                    name={`year`}
                    control={control}
                    rules={{
                      required: `The year is required`
                    }}
                    render={({ field }) => {
                      const selectedBrandId = watch("brand_id");
                      const selectedModelId = watch("model_id");

                      const selectedBrand = vehicleBrands.find(
                        (brand) => brand.id == selectedBrandId
                      );

                      const selectedModel = selectedBrand?.models.find(
                        (model) => model.id == selectedModelId
                      );

                      const availableYear = selectedModel?.active_years || [];

                      return (

                        <Autocomplete
                          size="small"
                          options={availableYear.map((option) => {
                            return {
                              label: option,
                              id: option
                            }
                          })}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              <div className="label-size m-0">{option.label}</div>
                            </li>
                          )}



                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select year"
                              error={!!errors?.year}
                            />
                          )}
                        />

                      );
                    }}
                  />

                  {errors?.year && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.year?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="row mt-2">

              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Plate Number</label>
                  <TextField

                    size="small"
                    style={{ outlineColor: "black", }}
                    className='w-100 ' type='text' placeholder='Add plate number'
                    {...register("plate_number",
                      {
                        required: "The plate Number is Required"
                      }
                    )}
                    error={!!errors?.plate_number}
                  />
                  {errors?.plate_number && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.plate_number?.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label htmlFor="">Chassis Number</label>
                  <TextField
                    size="small"
                    style={{ outlineColor: "black", }}
                    className='w-100 ' type='text' placeholder='Add chassis number'
                    {...register("chassis_number")}
                  />
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="">
                  <label className="" htmlFor="">Odometer Reading</label>
                  <TextField
                    size="small"
                    style={{ outlineColor: "black", }}
                    className='w-100 ' type='text' placeholder='Add odometer reading'
                    {...register("odometer_reading")}
                  />
                </div>
              </div>
            </div>



            <div className="row mt-2">
              {properties.map((prop, index) => (
                <div key={prop.id} className="col-xl-4 col-12 my-2">
                  <label>{prop.name}</label>

                  <Controller
                    name={`properties.${index}.value_id`}
                    control={control}
                    rules={{
                      required: `${prop.name} is required`
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={prop.values.map((option) => ({
                          label: option.value,
                          id: option.id,
                        }))}
                        value={
                          prop.values
                            .map(v => ({ label: v.value, id: v.id }))
                            .find(v => v.id == field.value) || null
                        }
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : "")
                        }}
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            <div className="label-size m-0">{option.label}</div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${prop.name}`}
                            error={!!errors?.properties?.[index]?.value_id}
                          />
                        )}
                      />
                    )}

                  />
                  {errors?.properties?.[index]?.value_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.properties?.[index]?.value_id?.message}
                    </p>
                  )}
                </div>
              ))}
            </div>


      
            <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
              <button className="btn btn-dark px-5">Save</button>
              <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="d-flex">
        <div className="w-100  ">

          <div className="min-vh-100 m-4">
          
            <div className="d-flex justify-content-between align-items-center header-responsive ">
              <h5 className="m-0 fw-bold">Services vans</h5>
              <div className="d-flex align-items-center gap-2 btn-vans-responsive">
                <div className="date-remove-space">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer


                      components={["DatePicker"]}

                    >
                      <DatePicker
                        slotProps={{ textField: { size: 'small' } }}
                        label="select Date"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                <div className="">
                  <button
                    onClick={handleShow}
                    className="btn btn-dark rounded-2 text-white d-block"
                  >
                    <AddIcon className="text-white" />
                    Add Vehicles
                  </button>
                </div>
              </div>
            </div>
            <div className=" border mt-3 p-3 rounded-2 min-vh-100  ">
              {loading && <div className="text-center">
              Loading...
              </div>}
              <div className="row ">
                {vanList.map((van) => (
                  <VanCard key={van?.id} van={van} getVanList={getVanList}/>
                ))}

              </div>
                {!loading &&
                   <div className="d-flex justify-content-center my-2">
              
          <Stack spacing={2}>
  <Pagination
    count={pagination?.last_page }   
    page={page}          
    onChange={(event, value) => setPage(value)} 
    shape="rounded"
  />
</Stack>
            </div>
                
                }
             
            </div>
          
          </div>
        </div>
      </div>
    </>
  );
};

export default Vehicles;
